import { useAction } from '@sde/widgets-core/src/redux/hooks/useAction';
import { useSelect } from '@sde/widgets-core/src/redux/hooks/useSelect';

import {
  setMember,
  openRecentSearchFlyout,
  setRecentSearch,
  loadRecentSearches,
  clearRecentSearches,
  setSelectedPLNProvider,
  toggleOONWidget,
  setClaimsCriteria,
  setEligibilityCriteria,
  setReferralCriteria,
  openTrackItFlyout,
  searchCurrentMember,
  handleDocLibSearchFlyout,
  updateProviderPreferenceError,
  setViewedProviderChatModal,
  setProviderPreferenceComplete,
} from './actions';

const dashboardSelector = (state) => state.dashboard;

export const useDashboard = {
  state: () => {
    const dashboard = useSelect(dashboardSelector);
    return {
      dashboard,
      claimsCriteria: dashboard.searchCriteria.claims,
      eligibilityCriteria: dashboard.searchCriteria.eligibility,
      trackItFlyout: dashboard.trackItFlyout,
      referralCriteria: dashboard.searchCriteria.referral,
      searchCurrentMember: dashboard.searchCurrentMember,
      docLibSearchFlyout: dashboard.docLibSearchFlyout,
      providerPreferenceError: dashboard.providerPreferenceError,
      viewedProviderChatModal: dashboard.viewedProviderChatModal,
      providerPreferenceComplete: dashboard.providerPreferenceComplete,
    };
  },
  actions: () => {
    return {
      setMember: useAction(setMember),
      openRecentSearchFlyout: useAction(openRecentSearchFlyout),
      setRecentSearch: useAction(setRecentSearch),
      loadRecentSearches: useAction(loadRecentSearches),
      clearRecentSearches: useAction(clearRecentSearches),
      setSelectedPLNProvider: useAction(setSelectedPLNProvider),
      toggleOONWidget: useAction(toggleOONWidget),
      setClaimsCriteria: useAction(setClaimsCriteria),
      setEligibilityCriteria: useAction(setEligibilityCriteria),
      setReferralCriteria: useAction(setReferralCriteria),
      openTrackItFlyout: useAction(openTrackItFlyout),
      searchCurrentMember: useAction(searchCurrentMember),
      handleDocLibSearchFlyout: useAction(handleDocLibSearchFlyout),
      updateProviderPreferenceError: useAction(updateProviderPreferenceError),
      setViewedProviderChatModal: useAction(setViewedProviderChatModal),
      setProviderPreferenceComplete: useAction(setProviderPreferenceComplete),
    };
  },
};
